<template>
    <v-dialog v-model="dialog"  transition="dialog-top-transition" persistent class="customePopupWidth">
      <v-toolbar>
        <v-toolbar-title><span v-if="id === 0">Add</span> <span v-else> Edit</span> Password</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn variant="outlined" @click="$emit('close-modal', id)" class="mr-2">
          Back
        </v-btn>
        <v-btn variant="flat" color="primary" @click="$refs.submitBtn.$el.click()" :disabled="loading">
          <v-progress-circular indeterminate v-if="loading" size="20" width="3"></v-progress-circular>
          Save
        </v-btn>
      </v-toolbar>
      <v-card class="pa-4 filter-popup-min-height" :loading="loading">
        <v-form ref="myForm" v-model="valid" @submit.prevent="save" lazy-validation class="pa-4">
          <v-row>
            <v-col sm="12" lg="6" md="6" cols="12">
                <v-text-field v-model="user_info.password" id="password" name="password" placeholder="Password"
                    label="New Password" autocomplete="off" :type="show ? 'text' : 'password'"
                    :append-inner-icon="show ? 'mdi-eye' : 'mdi-eye-off'" @click:append-inner="toggelEyeIcon('show')"
                    density="compact" variant="outlined" :rules="rules.required">
                  </v-text-field>
            </v-col>
            <v-col sm="12" lg="6" md="6" cols="12">
                <v-text-field v-model="user_info.cnf_password" id="cnf_password" name="cnf_password" placeholder="Password"
                    label="Confirm Password" autocomplete="off" :type="show1 ? 'text' : 'password'"
                    :append-inner-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"  @click:append-inner="toggelEyeIcon('show1')"
                    density="compact" variant="outlined" :rules="rules.required">
                  </v-text-field>
            </v-col>
          </v-row>
          <v-btn variant="flat" ref="submitBtn" type="submit" class="d-none"> Submit </v-btn>
        </v-form>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import ValidationRules from "../../components/Validation";
  import UserService from "../../services/user.service";
  export default {
    name: "splash-theme-add-edit",
    props: {
      id: 0,
    },
    mounted() {
      let user_id=this.$store.state.auth.user.id;
      this.addEdit(user_id);
    },
    computed: {
      rules() {
        return ValidationRules;
      },
      loading() {
        return this.$store.state.theme.isLoading;
      }
    },
    data: () => ({
      user_info: {
        id: '',
        password:'',
        cnf_password:'',

      },
      dialog: true,
      notifications: false,
      sound: true,
      widgets: false,
      valid: true,
      validationTypes: [
        { value: "none", label: 'None' },
      ],
      
      add_options: '',
      show:false,
       show1:false
    }),
    methods: {
      createImage(file) {
        const reader = new FileReader();
        
        reader.onload = (e) => {
          this.imageUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      },
      onChange(e) {
        let reader = new FileReader();
        reader.onload = function(e) {
            this.setState({file: reader.result})
        }
        reader.readAsDataURL(e.target.files[0]);
      },
      async addEdit(user_id) {
        if (user_id > 0) {
          try {
            this.$store.dispatch('theme/updateIsLoading', true);
            UserService.edit(user_id)
              .then(response => {
                if (response.data.success === true) {
                  //this.user_info = response.data.data;
                  this.$store.dispatch('theme/updateIsLoading', false);
                } else {
                  this.$SweetToast.error(response.data.message);
                  this.$store.dispatch('theme/updateIsLoading', false);
                }
              })
              .catch(e => {
                console.log(e);
                this.$SweetToast.error("Something went wrong!, Please try again.");
                this.$store.dispatch('theme/updateIsLoading', false);
              });
          } catch (err) {
            this.$store.dispatch('theme/updateIsLoading', false);
            console.log(err);
          }
        }
  
      },
      async save() {
        const { valid } = await this.$refs.myForm.validate();
        let uinfo=this.$store.state.auth.user;
        this.user_info.id=uinfo.id;
        if (valid) {
          this.$store.dispatch('theme/updateIsLoading', true);
          try {
            let apiCall;
           
            apiCall = UserService.updatePassword(this.user_info)
            
            apiCall.then(response => {
              if (response.data.success === true) {
                this.$SweetToast.success(response.data.message);
                this.$store.dispatch('theme/updateIsLoading', false);
                this.$emit('close-modal', 'saved');
              } else {
                this.$SweetToast.error(response.data.message);
                this.$store.dispatch('theme/updateIsLoading', false);
              }
            })
              .catch(e => {
                console.log(e);
                this.$SweetToast.error("Something went wrong!, Please try again.");
                this.$store.dispatch('theme/updateIsLoading', false);
              });
          } catch (err) {
            this.$store.dispatch('theme/updateIsLoading', false);
            console.log(err);
          }
  
        }
      },
      submitForm() {
        this.$refs.submitBtn.$el.click();
      },
      toggelEyeIcon(field)
      {
        if(field=='show')
        {
           this.show = !this.show 
        }
         if(field=='show1')
        {
           this.show1 = !this.show1 
        }
        
      }
    },
  };
  </script>
  